import { render, staticRenderFns } from "./serviceCmmodityAdd.vue?vue&type=template&id=3c348f4a&scoped=true"
import script from "./serviceCmmodityAdd.vue?vue&type=script&lang=js"
export * from "./serviceCmmodityAdd.vue?vue&type=script&lang=js"
import style0 from "./serviceCmmodityAdd.vue?vue&type=style&index=0&id=3c348f4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c348f4a",
  null
  
)

export default component.exports